import * as React from "react";
import { renderLiveStreamingIcon } from "./renderLiveStreamingIcon";
import { renderStatisticsIcon } from "./renderStatisticsIcon";
import { renderFastMarketIcon } from "./renderFastMarketIcon";
import { renderPulseBetIcon } from "./renderPulseBetIcon";
import { getDictPhrase } from "../../../../../helpers";
import { renderMbnIcon } from "./renderMbnIcon";
export const renderEventIcons = (event, dict, isDesktop, handlers, componentPrefix) => {
    let firstIcon, secondIcon;
    if (event.mbnIcon && event.mbnIcon.active) {
        firstIcon = renderMbnIcon(event.mbnIcon.tagNumber);
        secondIcon = renderFirstAvailableIcon(event, dict, isDesktop, handlers, true);
    }
    else {
        firstIcon = renderFirstAvailableIcon(event, dict, isDesktop, handlers, false);
        secondIcon = renderLiveStreamingIcon(event.livestreamIcon.active, getDictPhrase(dict, event.livestreamIcon.tooltip), true, handlers.liveStream);
    }
    return React.createElement(React.Fragment, null,
        firstIcon,
        secondIcon);
};
const renderFirstAvailableIcon = (event, dict, isDesktop, handlers, shouldShowLiveStreaming) => {
    if (shouldShowLiveStreaming && event.livestreamIcon.active) {
        return renderLiveStreamingIcon(event.livestreamIcon.active, getDictPhrase(dict, event.livestreamIcon.tooltip), true, handlers.liveStream);
    }
    if (isDesktop) {
        if (event.statisticsIcon.active) {
            return renderStatisticsIcon(event.statisticsIcon.active, getDictPhrase(dict, event.statisticsIcon.tooltip), handlers.statistics);
        }
    }
    else {
        if (event.pulsebetIcon.active) {
            return renderPulseBetIcon(event.pulsebetIcon.active, getDictPhrase(dict, event.pulsebetIcon.tooltip));
        }
    }
    return renderFastMarketIcon(event.fastmarketIcon.active, getDictPhrase(dict, event.fastmarketIcon.tooltip));
};
//# sourceMappingURL=renderEventIcons.js.map